import OneLinkUrlGenerator from "@lib/oneLinkUrlGenerator";
import { getTrafficSource } from "@lib/trafficSource";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export default function useOneLinkUrl(
  initialUrl: string,
  allowDeepLink?: boolean,
  deepLinkPath?: string
) {
  const { asPath, locale } = useRouter();
  const [url, setUrl] = useState(initialUrl);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const oneLinkGenerator = new OneLinkUrlGenerator({
        oneLinkURL: initialUrl,
        pidKeysList: ["af_pid", "utm_source"],
        // The generator reads pid off window.location, so in-site navigation
        // drops it and the install lands as organic. Fall back to the source
        // this tab landed with; a param still in the URL takes priority.
        pidStaticValue: getTrafficSource(),
        campaignKeysList: ["af_c", "utm_campaign"],
        skipList: [],
      });

      oneLinkGenerator.setDeepLinkValue(
        "deep_link_value",
        deepLinkPath ?? asPath
      );
      oneLinkGenerator.setAfSub1("url", asPath);
      oneLinkGenerator.setAdset("language", locale);

      setUrl(oneLinkGenerator.generateUrl(allowDeepLink));
    }
  }, [initialUrl, allowDeepLink, deepLinkPath, asPath, locale]);

  return url;
}
